// extracted by mini-css-extract-plugin
export default {"body":"confirm-modal_body__zlOh7","text":"confirm-modal_text__3rEhf","actions":"confirm-modal_actions__9UCxH"};